import React from 'react';

import {FullTextFilter, Operator} from '../SearchConstants';
import {BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import TextValueFilterForm from './base/TextValueFilterForm';

export interface ResiduesFilterFormProps extends BaseFilterFormProps {
  filter: FullTextFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: FullTextFilter) => void;
  onRemove?: () => void;
  operators: Array<Operator>;
  placeholder: string;
}

export default function ResiduesFilterForm(props: ResiduesFilterFormProps): JSX.Element {
  return (
    <TextValueFilterForm
      {...props}
      filterStyle={props.filterStyle}
      onChangeValue={(value: string) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onChangeOperator={(operator: Operator) => {
        props.onChangeFilter({
          ...props.filter,
          value: props.filter.value ?? '',
          operator,
        });
      }}
      onRemove={props.onRemove}
      operators={props.operators}
      selectedOperator={props.filter.operator}
      initialValue={props.filter.value || ''}
    />
  );
}
